import styled from 'styled-components';
import Parent from '../Base/style';

const Container = styled(Parent.Container)``;
const LeftStick = styled(Parent.LeftStick)``;
const RightStick = styled(Parent.RightStick)``;

const ErrorIconComponent = { Container, LeftStick, RightStick };
export default ErrorIconComponent;
